(function () {
    'use strict';

    angular.module('swif.ui')
    .config(route)
    .controller('LegalController', LegalController)
    .controller('BodyController', BodyController)

    .directive('swifColScroll', swifColScroll)
    .directive('swifFixCalendarSize', swifFixCalendarSize)

    .directive('setMinHeightToWindowHeight', setMinHeightToWindowHeight)
    .directive('swifListener', swifListener)

    .directive('iframeLoaded', iframeLoaded);



    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/about', {
            templateUrl: 'about.html',
            controller: function($scope, settings) {
                'ngInject';
                $scope.app = settings.app;
            }
        });
        $routeProvider.when('/legal', {
            templateUrl: 'cgu.html',
            controller: 'LegalController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifOpenbaseCompanyService', function(service) {
                    return service.getLegals();
                }]
            }
        });
        $routeProvider.when('/suggestions', {
            templateUrl: 'crowdfunding.html',
            controllerAs: '$ctrl',
            controller: function($scope, swif) {
                'ngInject';
                var $ctrl = this;

                swif.route.check().then(_ => {
                    $ctrl.loading = true;
                    $ctrl.loaded = function() {
                        $ctrl.loading = false;
                        $scope.$apply();
                    }
                });

            }
        });
    }

    function LegalController($scope, $sce, data) {
        'ngInject';
        $scope.legalText = $sce.trustAsHtml(data);
    }


    function BodyController($scope, $q, $location, $http, $interval, settings, msgService, dataService, userService){
        'ngInject';
        console.log('init BodyController');
        //TODO: delete this stuff

        $scope.initialized = false;

        settings.initialize().then(function () {
            $scope.initialized = true;
        });
    }


    function swifColScroll() {
        return function (scope, element) {
            var $window = $(window);
            var setHeight = function() {
                element.height($window.height() - 100);
            };
            $( document ).ready(function () {
                element.css('overflow-y', 'auto');
                setHeight();
                $window.resize(setHeight);
            });
            scope.$on('$destroy', function () {
                $window.off('resize', setHeight);
            });
        };
    }


    function swifFixCalendarSize($window) {
        'ngInject';
        return {
            restrict: 'E',
            scope: {
                height: '@',
                marginBottomScreen: '@',
                config: '='
            },
            link: function (scope, element) {
                console.log('Directive swifFixCalendarSize');
                var updateHeight = function (newV) {
                    var value = 0;
                    if(scope.height) {
                        value = scope.isPercent ? newV * scope.heightValue / 100 : scope.heightValue;
                    }
                    else if(scope.marginBottomScreen) {
                        var offset = element[0].getBoundingClientRect();
                        value = newV - offset.top - scope.marginBottomScreenValue;
                    }
                    scope.config.height = value;
                };
                // default value, if no parameter is defined, this value will be used
                // (so element will be displayed 'atached' to the bottom of the screen)
                scope.marginBottomScreen = scope.marginBottomScreen || '0';
                // according to the parameter supplied, parse its string value into an Integer
                if(scope.height) {
                    scope.isPercent = scope.height[scope.height.length - 1] === '%';
                    scope.heightValue = parseInt(scope.height.replace('%', '').replace('px', ''), 10);
                }
                else if(scope.marginBottomScreen) {
                    scope.marginBottomScreenValue = parseInt(scope.marginBottomScreen.replace('px', ''), 10);
                }
                updateHeight($window.innerHeight);
                $(window).on('resize.swifFixCalendarSizeEvent', function() {
                    scope.$apply(function() {
                        updateHeight(window.innerHeight);
                    });
                    scope.$on('$destroy', function() {
                        $(window).off('resize.swifFixCalendarSizeEvent');
                    });
                });
            }
        };
    }


    function setMinHeightToWindowHeight() {
        return {
            restrict: 'A',
            link: function () {
                $('#page-wrapper').css('min-height', function () {
                    return $(window).height() - 120;
                });
            }
        };
    }

    function swifListener() {
        return {
            restrict: 'EA',
            require: 'ngModel',
            scope: {
                callback: '&?',
                swifListener: '=?',
                ngModel: '='
            },
            link: function (scope, element, attr, ngModel) {
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    var fnct = scope.callback || scope.swifListener;
                    if (fnct) {
                        fnct();
                    }
                };
                // usefull when listener an entire object (otherwise, reference listener only)
                if (scope.swifListenerDeep) {
                    scope.$watch('ngModel', function (newV, oldV) {
                        if (!angular.equals(newV, oldV)) {
                            ngModel.$render();
                        }
                    }, true);
                }
            },
            template: ''
        };
    }

    function iframeLoaded() {
        return {
            scope: {
                callback: '&iframeLoaded'
            },
            link: function(scope, element, attr) {
                element.on('load', function() {
                    return scope.callback();
                });
            }
        }
    }

})();
